import { CDN_LINK } from "@globalConfig";
export var getUSPData = function getUSPData(t) {
  return {
    title: t("why_syarah_biggest_online_car", {
      ns: "web_car_show_rooms"
    }),
    images: [{
      title: t("largest_selection_kingdom", {
        ns: "web_car_show_rooms"
      }),
      desc: t("provided_2_000_cars_choose", {
        ns: "web_car_show_rooms"
      }),
      image: CDN_LINK + "/assets/images/USP/carShowRooms/biggest_collection.svg"
    }, {
      title: t("buy_try_10_days_free", {
        ns: "web_car_show_rooms"
      }),
      desc: t("try_car_10_days_fails", {
        ns: "web_car_show_rooms"
      }),
      image: CDN_LINK + "/assets/images/USP/carShowRooms/try_it_10.svg"
    }, {
      title: t("warranty_up_3_years", {
        ns: "web_car_show_rooms"
      }),
      desc: t("warranty_includes_repairs_spare_parts", {
        ns: "web_car_show_rooms"
      }),
      image: CDN_LINK + "/assets/images/USP/carShowRooms/warranty.svg"
    }, {
      title: t("deliver", {
        ns: "web_car_show_rooms"
      }),
      desc: t("stay_home_buy_car_online", {
        ns: "web_car_show_rooms"
      }),
      image: CDN_LINK + "/assets/images/USP/carShowRooms/delivery.svg"
    }]
  };
};